import {
  LegalClientSourcesOfIncomeFinancialSourceType,
  LegalClientSourcesOfIncomeSourceType,
} from 'api/types/entity';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  string,
  object,
  array,
  selectSchema,
} from 'libs/form';
import { TFunc } from 'libs/i18n';
import { localFileScheme } from 'modules/client/common/helpers';
import { SelectType } from 'types/selectType';

import { LocalFileEntity } from '../types';

export interface SourcesOfIncomeFormType {
  sourcesOfIncome: {
    incomeSources: SelectType<LegalClientSourcesOfIncomeSourceType>[];
    financialSources: SelectType<LegalClientSourcesOfIncomeFinancialSourceType>[];
    otherIncomeSource?: string;
    otherFinancialSource?: string;
    files: LocalFileEntity[];
  };
}

const isOtherIncomeSource = (
  values: SelectType<LegalClientSourcesOfIncomeSourceType>[]
) =>
  values?.find(
    (v) => v?.value === LegalClientSourcesOfIncomeSourceType.Other
  ) !== undefined;

const isOtherFinancialSource = (
  values: SelectType<LegalClientSourcesOfIncomeFinancialSourceType>[]
) =>
  values?.find(
    (v) => v?.value === LegalClientSourcesOfIncomeFinancialSourceType.Other
  ) !== undefined;

export const getSourcesOfIncomeSchema = (
  t: TFunc
): ObjectSchema<SourcesOfIncomeFormType> =>
  object({
    sourcesOfIncome: object({
      otherIncomeSource: string().when('incomeSources', {
        is: isOtherIncomeSource,
        then: (schema) => schema.required(),
      }),
      otherFinancialSource: string().when('financialSources', {
        is: isOtherFinancialSource,
        then: (schema) => schema.required(),
      }),

      incomeSources: array()
        .of(
          selectSchema(Object.values(LegalClientSourcesOfIncomeSourceType))
            .default(null)
            .required()
        )
        .min(1, t('validation.required'))
        .required(),

      financialSources: array()
        .of(
          selectSchema(
            Object.values(LegalClientSourcesOfIncomeFinancialSourceType)
          )
            .default(null)
            .required()
        )
        .min(1, t('validation.required'))
        .required(),

      files: array().of(localFileScheme.required()).required().min(1),
    }),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<SourcesOfIncomeFormType>();

export type FormErrors = FormErrorsBase<SourcesOfIncomeFormType>;
